import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function FinanceIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 17 17">
      <path
        d="M5.47 8.765V5.816q0-.433.303-.737.303-.303.737-.303t.738.303.303.737v2.95q0 .433-.303.737a1 1 0 0 1-.738.303q-.434 0-.737-.303a1 1 0 0 1-.304-.738m3.469-.156V3.041q0-.435.303-.737Q9.546 2 9.98 2t.737.304.304.737v5.568q0 .52-.321.78-.321.261-.72.261t-.72-.26-.321-.78M2 11.003V8.592q0-.434.304-.737.303-.304.737-.304t.737.304.304.737v2.411q0 .52-.321.78-.321.261-.72.261t-.72-.26-.321-.78m1.665 4.216q-.45 0-.633-.425-.182-.426.148-.755l2.845-2.845a.7.7 0 0 1 .46-.208.62.62 0 0 1 .476.173l1.978 1.7 3.886-3.885h-.417a.67.67 0 0 1-.494-.2.67.67 0 0 1-.2-.494q0-.295.2-.495a.67.67 0 0 1 .494-.2h2.082q.295 0 .494.2.2.2.2.495v2.081a.67.67 0 0 1-.2.495.67.67 0 0 1-.494.2.67.67 0 0 1-.494-.2.67.67 0 0 1-.2-.495v-.416L9.46 14.282a.7.7 0 0 1-.46.208.62.62 0 0 1-.476-.174l-1.978-1.7-2.394 2.394a.8.8 0 0 1-.217.148.6.6 0 0 1-.269.06"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
